// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class ImageUrlSizes extends Immutable.Record({
  small: String(),
  medium: String(),
  large: String()
}) {
  // No methods
}

ImageUrlSizes.reviver = keyedReviver(ImageUrlSizes, {
  // No nested data structures
})

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  ImageUrlSizes.propTypes = {
    small: PropTypes.string,
    medium: PropTypes.string,
    large: PropTypes.string
  }
}

module.exports = ImageUrlSizes
